/** @module Enums */ /** typedoc */

export enum NotificationTypeEnum {
    Expiration = 'expiration',
    Invitation = 'invitation',
    ReferralInviteeConverted = 'referralInviteeConverted',
    Listen = 'listen',
    Master = 'master',
    Message = 'message',
    Preview = 'preview',
    Payment = 'payment', // Deprecated - replaced by PaymentConfirmation but still needed for legacy notifications
    PaymentConfirmation = 'paymentConfirmation',
    PaymentFailed = 'paymentFailed',
    PaymentFailureInitialSkipped = 'paymentFailureInitialSkipped',
    PaymentSkipped = 'paymentSkipped',
    PaymentSuspended = 'paymentSuspended',
    PayoutCompleted = 'payoutCompleted',
    ProjectCollaboratorInvited = 'projectCollaboratorInvited',
    ProjectCollaboratorJoined = 'projectCollaboratorJoined',
    ReleaseAccepted = 'releaseAccepted',
    ReleaseLiveApple = 'releaseLiveApple', // Deprecated - Replaced by "ReleaseLive"
    ReleaseLiveSpotify = 'releaseLiveSpotify', // Deprecated - Replaced by "ReleaseLive"
    ReleaseLive = 'releaseLive',
    ReleasePaused = 'releasePaused',
    ReleasePlayCount = 'releasePlayCount',
    ReleaseRejected = 'releaseRejected',
    ReleaseShareReady = 'releaseShareReady',
    ReminderInvitation = 'reminderInvitation',
    RequestShareAccess = 'requestShareAccess',
    ShareReaction = 'shareReaction',
    AssetCollaboratorInvited = 'assetCollaboratorInvited',
    TrackInvitationReminder = 'trackInvitationReminder',
    AssetCommentCreated = 'assetCommentCreated',
    AlbumReady = 'albumReady',
    Unsupported = 'unsupported',
}

export enum NotificationCategoryEnum {
    Billing = 'billing',
    Collaboration = 'collaboration',
    Referral = 'referral',
    Distribution = 'distribution',
    Mastering = 'mastering',
    Promotion = 'promotion',
    Unsupported = 'unsupported'
}

// For Analytics
export enum NotificationCategoryFromTypeEnum {
    Expiration = NotificationCategoryEnum.Collaboration,
    Invitation = NotificationCategoryEnum.Collaboration,
    Listen = NotificationCategoryEnum.Collaboration,
    Master = NotificationCategoryEnum.Mastering,
    Message = NotificationCategoryEnum.Collaboration,
    Payment = NotificationCategoryEnum.Billing,
    PaymentFailed = NotificationCategoryEnum.Billing,
    PaymentFailureInitialSkipped = NotificationCategoryEnum.Billing,
    PaymentSkipped = NotificationCategoryEnum.Billing,
    PaymentSuspended = NotificationCategoryEnum.Billing,
    PayoutCompleted = NotificationCategoryEnum.Billing,
    Preview = NotificationCategoryEnum.Mastering,
    ProjectCollaboratorInvited = NotificationCategoryEnum.Collaboration,
    ProjectCollaboratorJoined = NotificationCategoryEnum.Collaboration,
    ReferralInviteeConverted = NotificationCategoryEnum.Referral,
    ReleaseAccepted = NotificationCategoryEnum.Distribution,
    ReleaseLive = NotificationCategoryEnum.Distribution,
    ReleaseLiveApple = NotificationCategoryEnum.Distribution,
    ReleaseLiveSpotify = NotificationCategoryEnum.Distribution,
    ReleasePaused = NotificationCategoryEnum.Distribution,
    ReleasePlayCount = NotificationCategoryEnum.Distribution,
    ReleaseRejected = NotificationCategoryEnum.Distribution,
    ReleaseShareReady = NotificationCategoryEnum.Promotion,
    ReminderInvitation = NotificationCategoryEnum.Collaboration,
    RequestShareAccess = NotificationCategoryEnum.Collaboration,
    ShareReaction = NotificationCategoryEnum.Collaboration,
    AssetCollaboratorInvited = NotificationCategoryEnum.Collaboration,
    AssetCommentCreated = NotificationCategoryEnum.Collaboration,
    TrackInvitationReminder = NotificationCategoryEnum.Collaboration,
    // AlbumReady = NotificationCategoryEnum.Mastering, TODO: check in which category to put
    Unsupported = NotificationCategoryEnum.Unsupported
}
